var map = {
	"./ship-cargo.png": 60384,
	"./ship-fishing.png": 63384,
	"./ship-high-speed-craft.png": 97308,
	"./ship-navigation.png": 55448,
	"./ship-passenger.png": 7088,
	"./ship-pleasure.png": 11416,
	"./ship-tanker.png": 89228,
	"./ship-tug-special.png": 4800,
	"./ship-unspecified.png": 52524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69864;